import { useContext } from "react";
import { InboxEmbedContext } from "./InboxEmbedContext";

/**
 * Stacking and density overrides for a conversation rendered inside a floating
 * host (the CRM-1133 message pop-up). Undefined on the /inbox route, where every
 * layer keeps its own defaults.
 */
export const useInboxEmbed = () => useContext(InboxEmbedContext);
